import { useQuery } from "@tanstack/react-query";
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
  collectorApiPost,
} from "../../../../API/collectorApi/collectorApi";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { GStore } from "../../../../context/Context";
import { FETCHING_OF, FETCHING_START, FETCHING_SUCCESS_COLLECTOR } from "../../../../state/actionTypes/actionTypes";
import { webTittle } from "../../../sheard/webTittle";
import CollectorModal from "../CollectorModal/CollectorModal";

const Collector = () => {
  webTittle("কালেক্টর")
  const { register, handleSubmit ,reset } = useForm();
  const { english, state  ,dispatch } = useContext(GStore);
  const {collectors :collectorData, user :{userNumber} } = state;
 

  const handleAddCollector = (data) => {
    
    dispatch({type: FETCHING_START})
    data.adminNumber = userNumber;
    // console.log(data);
    dispatch({type : FETCHING_SUCCESS_COLLECTOR , payload : [...state.collectors, data]})
    collectorApiPost(data);
    reset()
    dispatch({type: FETCHING_OF})
  };
  return (
    <div className="mx-2">
      <div>
        <div>
          <div className="flex justify-between items-center">
            <h2 className="text-3xl m-5 font-bold ">
              <ConvertEnglish english={" Collector"} bangla={" কালেক্টর"} />
            </h2>
            <label
              htmlFor="add-collector-modal"
              className="btn btn-outline text-1xl m-5 font-bold "
            >
              <ConvertEnglish
                english={"Add Collector"}
                bangla={"সংযোগ কালেক্টর"}
              />
            </label>
          </div>
          <div>
            <table className="table w-full text-center">
              {/* <!-- head --> */}
              <thead>
                <tr>
                  <th>
                    <ConvertEnglish
                      english={"Collector Name"}
                      bangla={"কালেক্টর নাম"}
                    />
                  </th>
                  <th className="hidden lg:block">
                    <ConvertEnglish
                      english={"Collector Address"}
                      bangla={"কালেক্টর ঠিকানা"}
                    />
                  </th>
                  <th>
                    <ConvertEnglish
                      english={"Collector Mobile"}
                      bangla={"কালেক্টর মোবাইল"}
                    />
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {/* <!-- row 1 --> start*/}

                {collectorData &&
                  collectorData?.map((cdata, i) => 
                    <tr key={cdata._id} className="border-b">
                      <td>
                        <p>{cdata?.name}</p>
                      </td>
                      <td className="hidden lg:block">
                        <p>{cdata?.address}</p>
                      </td>
                      <td>
                        <p>{cdata?.number}</p>
                      </td>
                      <td>
                        <div className="dropdown dropdown-left">
                          <label tabIndex={0} className="cursor-pointer m-1">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"></path></svg>
                          </label>
                          <ul
                            tabIndex={0}
                            className="dropdown-content menu p-2 shadow bg-base-100 rounded-box "
                          >
                            <li>
                              <a>Item 1</a>
                            </li>
                            <li>
                              <a>Item 2</a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  )}

                {/* <!-- row 1 --> end*/}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <CollectorModal
        loading={state.loading}
        handleAddCollector={handleAddCollector}
        register={register}
        handleSubmit={handleSubmit}
      ></CollectorModal>
    </div>
  );
};

export default Collector;
